
export default function Slider({words}) {

	const words_default = [
		<p className="font-bold">TECHKSHETRA</p>,
		"*",
		"2022",
		"*",
		<p className="font-bold">WORKSHOPS</p>,
		"*",
		"TECHTALKS",
		"*",
		<p className="font-bold">FOOD</p>,
		"*",
		"AMPLIFY",
		"*",
	];

	const Data = (words === undefined) ? words_default : words

	return (
		<div className="flex h-16 items-center justify-center smm:h-12">
		{/* 1. */}
		<div className="w-[200%] h-16 border-t border-b border-gray-600 overflow-hidden relative smm:h-12">
			{/* 2. */}
			<div className="w-[200%] flex items-center h-16 justify-around absolute left-0 animate gap-20 animate smm:h-12">
			{/* 3 */}
			{Data.map((i) => {
				return (
				<div className="flex justify-center items-start w-[20rem]">
					<p>{i}</p>
				</div>
				);
			})}
			{Data.map((i) => {
				return (
				<div className="flex justify-center items-start w-[20rem]">
					<p>{i}</p>
				</div>
				);
			})}
			</div>
		</div>
		</div>
	);
}
